import { render, staticRenderFns } from "./ReleaseLinkIcons.vue?vue&type=template&id=da61a00e&scoped=true&"
import script from "./ReleaseLinkIcons.vue?vue&type=script&lang=ts&"
export * from "./ReleaseLinkIcons.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseLinkIcons.vue?vue&type=style&index=0&id=da61a00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da61a00e",
  null
  
)

export default component.exports